<script setup lang="ts">
import { computed } from 'vue'
import { useMenu } from '@/composables/useMenu'
import SidebarItem from './components/SidebarItem.vue'

const props = defineProps<{
  collapsed?: boolean
}>()

const { openKeys, selectedKeys, menuItems, handleOpenChange } = useMenu()
</script>

<template>
  <div class="sidebar-container">
    <!-- Logo -->
    <div class="sidebar-logo">
      <router-link to="/dashboard" class="logo-link">
        <img src="/logo.png" alt="小嘿工作台" class="logo-image" />
      </router-link>
    </div>

    <!-- 菜单 -->
    <a-menu
      v-model:open-keys="openKeys"
      v-model:selected-keys="selectedKeys"
      mode="inline"
      class="sidebar-menu"
      @open-change="handleOpenChange"
    >
      <SidebarItem 
        v-for="item in menuItems" 
        :key="item.path" 
        :item="item" 
      />
    </a-menu>
  </div>
</template>

<style scoped lang="scss">
.sidebar-container {
  height: 100%;
  overflow: hidden auto;
}

.sidebar-logo {
  padding: 8px 16px;
  
  .logo-link {
    display: block;
    height: 80px;
    line-height: 80px;
    text-decoration: none;
    overflow: hidden;
    white-space: nowrap;
    
    .logo-image {
      height: 65px;
      margin: 3.5px 3px;
      vertical-align: middle;
    }
  }
}

.sidebar-menu {
  border-right-color: transparent;
  border-inline-end: none !important;
}
</style>
